import { useState } from "react";
import { useSingleNews } from "../../actions/homeActions";
import { useNavigate, useParams } from "react-router-dom";
import { useFavouritelikeMutation } from "../../actions/homeActions";
import { useAuth } from "../../context/authContext";

export default () => {
  const { id } = useParams();
  const {
    data: singleNews,
    isLoading,
    isError,
    error,
    refetch,
  } = useSingleNews(id);
  const userId = localStorage.getItem("userId");
  const [loadingapi, setLoadingapi] = useState(false);
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const mutation = useFavouritelikeMutation(setLoadingapi);
  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">Error loading events: {error.message}</p>
      </div>
    );
  }
  const handleSevedEvent = (userId, news_id) => {
    if (!isLoggedIn) {
      navigate("/login");
    } else {
      setLoadingapi(true);
      mutation.mutate(
        {
          instance_id: news_id, // ID of the specific talent/news/event/job
          instance_type: "news", // Can be one of: "talent", "news", "event", "job"
          user_id: userId, // ID of the user performing the action
          record_type: "Favourite",
        },
        {
          onSettled: () => {
            refetch();
          },
        }
      );
    }
  };
  return { isLoading, singleNews, handleSevedEvent, userId, loadingapi };
};
